// extracted by mini-css-extract-plugin
export default {"page":"Reports_page__-zOF9","fadeIn":"Reports_fadeIn__G1Z77"};